import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { useComponent } from '../../../hooks/useComponent';
import SectionState from '../../common/SectionState';
import FAQBlock from './FAQBlock';
import FaqHeader from './FaqHeader';
import { FaqContainer } from './styles';
const FAQ = ({ componentType, entryId }) => {
    var _a;
    const theme = useTheme();
    const faq = useComponent(entryId, componentType);
    const { items } = (_a = faq === null || faq === void 0 ? void 0 : faq.fields) !== null && _a !== void 0 ? _a : {};
    const containerProps = {
        styles: {
            content: { position: 'relative', zIndex: 1 },
        },
        cap: theme.caps.big,
    };
    return (_jsx(SectionState, { children: _jsxs(FaqContainer, Object.assign({ direction: "row", pageTag: "faq" }, containerProps, { children: [_jsx(FaqHeader, Object.assign({}, faq === null || faq === void 0 ? void 0 : faq.fields)), !!items && _jsx(FAQBlock, Object.assign({}, faq === null || faq === void 0 ? void 0 : faq.fields))] })) }));
};
export default FAQ;
